import { Caption, CustomSelectOption, FormItem, Select } from '@vkontakte/vkui';
import { UserAvatar } from '../../components/UserAvatar';
import PropTypes from 'prop-types';
import React from 'react';

export const UserSelectComponent = ({error, setError, members, value, setValue, description, label, placeholder}) => {
  if (description) {
    description = description
      .replace(/([\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6})/g, '<span class="CopyToClipboard" onClick="copyToClipboard(\'$&\', \'Номер телефона скопирован\')">$&</span>')
      .replace(/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g, '<span class="CopyToClipboard" onClick="copyToClipboard(\'$&\', \'Номер телефона скопирован\')">$&</span>');

  }

  return (<FormItem
    top={label}
    status={error.length > 0 ? 'error' : ''}
    bottom={error}
  >
    <Select
      onChange={(event) => setValue(parseInt(event.target.value))}
      value={value || undefined}
      options={members}
      renderOption={({ option, ...restProps }) => (
        <CustomSelectOption
          {...restProps}
          key={option.value}
          before={<UserAvatar size={24} type={option.type || undefined} src={option.img} name={option.label} id={option.value} />}
        />
      )}
    />
    {
      description ? (<Caption
        level={'1'}
        className={'UserSelect__description'}
        dangerouslySetInnerHTML={{__html: description}}
      >
      </Caption>) : undefined
    }
  </FormItem>);
}

const member = PropTypes.shape({
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  label: PropTypes.string.isRequired,
  img: PropTypes.string
});

UserSelectComponent.protoType = {
  error: PropTypes.string.isRequired,
  setError: PropTypes.func.isRequired,
  members: PropTypes.arrayOf(member.isRequired).isRequired,
  value: PropTypes.number,
  setValue: PropTypes.func.isRequired,
  description: PropTypes.string,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
}
